
import React from 'react';

/**
 * AssumptionsPanel
 *
 * Renders a list of calculation assumptions with icons.
 * Includes basic defensive checks to avoid runtime errors if the
 * assumptions data is malformed.
 */
export default function AssumptionsPanel() {
  // Defensive copy – ensures the array can be safely iterated over
  const assumptions = [
    { icon: 'ri-plant-line', label: 'Wheel traffic destroys 3–5% of standing crop per pass' },
    { icon: 'ri-time-line', label: 'Missed spray windows reduce yield 7–15 bu/acre (soybeans)' },
    { icon: 'ri-shield-check-line', label: 'Deer browse costs ~$800/acre on unprotected edge rows' },
    { icon: 'ri-eye-line', label: 'Drainage issues cost $50–$120/acre in hidden yield loss' },
    { icon: 'ri-money-dollar-circle-line', label: 'Service costs based on current Mid-Atlantic pricing' },
  ];

  // Simple validation – if assumptions is not an array, render nothing
  if (!Array.isArray(assumptions) || assumptions.length === 0) {
    return null;
  }

  return (
    <div className="bg-emerald-50/60 border border-emerald-100 rounded-lg p-5">
      <h3 className="text-sm font-bold text-emerald-800 mb-3 flex items-center gap-2">
        <div className="w-4 h-4 flex items-center justify-center">
          <i className="ri-information-line text-emerald-700"></i>
        </div>
        What We Calculate
      </h3>

      <ul className="space-y-2.5">
        {assumptions.map((a, i) => {
          // Guard against missing properties
          const iconClass = typeof a.icon === 'string' ? a.icon : '';
          const label = typeof a.label === 'string' ? a.label : '';

          return (
            <li key={i} className="flex items-start gap-2.5">
              <div className="w-4 h-4 flex items-center justify-center mt-0.5 shrink-0">
                {/* Render a placeholder if the icon class is missing */}
                {iconClass ? (
                  <i className={`${iconClass} text-emerald-600 text-sm`}></i>
                ) : (
                  <i className="ri-question-line text-emerald-600 text-sm"></i>
                )}
              </div>
              <span className="text-xs text-gray-600 leading-relaxed">{label}</span>
            </li>
          );
        })}
      </ul>

      <p className="text-xs text-gray-400 mt-4 italic">
        Estimates based on USDA data, university extension research, and regional field observations.
        Actual results vary by operation.
      </p>
    </div>
  );
}
